const getEldConfig = () => {
    const {REACT_APP_PROD_URL, REACT_APP_LEGACY_PROD_URL, REACT_APP_PS_PROD_URL} = process.env
    const envRegex = {
        pr: /^https?:\/\/[^/]+-pr\d+/,
        local: /^https?:\/\/localhost:3000/,
        localAlternate: /^https?:\/\/localhost:3001/,
        dev: /^https?:\/\/[^/]+-dev[^/]+\/?/,
        qa: /^https?:\/\/[^/]+-qa[^/]+\/?/,
        staging: /^https?:\/\/[^/]+-staging[^/]+\/?/
    }
    if (REACT_APP_PROD_URL) envRegex.prod = new RegExp(`^https?://(www\\.)?${REACT_APP_PROD_URL.replace(/[/\-\\^$*+?.()|[\]{}]/g, '\\$&')}/?`)
    if (REACT_APP_LEGACY_PROD_URL) envRegex.legacyProd = new RegExp(`^https?://(www\\.)?${REACT_APP_LEGACY_PROD_URL.replace(/[/\-\\^$*+?.()|[\]{}]/g, '\\$&')}/?`)
    if (REACT_APP_PS_PROD_URL) envRegex.psProd = new RegExp(`^https?://(www\\.)?${REACT_APP_PS_PROD_URL.replace(/[/\-\\^$*+?.()|[\]{}]/g, '\\$&')}/?`)

    const url = window.location.href

    const findKey = (obj, predicate = o => o) => Object.keys(obj)
        .find(key => predicate(obj[key], key, obj))

    let environment = findKey(envRegex, env => env.test(url)) || 'qa'
    if (environment === 'legacyProd' || environment === 'psProd') environment = 'prod'

    const useMcRegex = /^https?:\/\/[^/]+\.platformscience[^/]+\/?/
    const use_mc = useMcRegex.test(url)

    const eldConfig = use_mc ? {
        qa: 'https://api.dev.telematicsplatform.io/compliance/eldrods/eld-ui',
        local: 'https://api.dev.telematicsplatform.io/compliance/eldrods/eld-ui',
        localAlternate: 'https://api.dev.telematicsplatform.io/compliance/eldrods/eld-ui',
        staging: 'https://api.staging.telematicsplatform.io/compliance/eldrods/eld-ui',
        prod: 'https://api.telematicsplatform.io/compliance/eldrods/eld-ui'
    } : {
        qa: 'https://tcx-compliance-eld-ui.dev.trimble-transportation.com',
        local: 'https://tcx-compliance-eld-ui.dev.trimble-transportation.com',
        localAlternate: 'https://tcx-compliance-eld-ui.dev.trimble-transportation.com',
        staging: 'https://tcx-compliance-eld-ui.stg.trimble-transportation.com',
        prod: 'https://tcx-compliance-eld-ui.trimble-transportation.com'
    }

    return eldConfig[environment]
}

module.exports = {getEldConfig}
